const getReturningUserData = require("../run/returningUser/getReturningUserData");
const submitRoiGateFormData = require("../run/roiCalculator/submitRoiGateFormData");
const destroyRoiGateForm = require("../run/roiCalculator/destroyRoiGateForm");
const convertRoiGateFormDataToUngatePayload = require("../run/roiCalculator/convertRoiGateFormDataToUngatePayload");
const ungateRoiCalculatorForm = require("../run/roiCalculator/ungateRoiCalculatorForm");

/**
 * @return {Promise<void>}
 */
module.exports = async function whenRoiCalculatorReturningUserCtaClicked() {
    const returningUserData = getReturningUserData();

    if (returningUserData) {
        try {
            void submitRoiGateFormData(returningUserData);
            destroyRoiGateForm();
            const ungatePayload = convertRoiGateFormDataToUngatePayload(returningUserData);
            ungateRoiCalculatorForm(ungatePayload)
        } catch (e) {
            console.error("Returning user form data could not be submitted!");
        }
    }
}
